import React from 'react';

import type { FieldIssue } from './fieldMap';

/**
 * What every field editor in a structured guide needs and none of them owns: the guide's slug (an
 * uploaded image is named after it), the section headings a placement can point at, and the inline
 * problems keyed by path. Threading these through eleven levels of props was the alternative.
 */
export interface StructuredContextValue {
  slug: string;
  headings: string[];
  issues: Map<string, FieldIssue>;
}

export const StructuredContext = React.createContext<StructuredContextValue>({
  slug: '',
  headings: [],
  issues: new Map(),
});

export const useStructured = () => React.useContext(StructuredContext);
